import React, { useState,useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import SearchableSelect from "../components/SearchableSelect";
import { savePartApi, deletePartApi, editPartApi, getPartDetailsApi } from "../Api/api";
import { useParts } from "../context/PartsContext";

function PartMaster() {
  // ===== STATES FOR FORM =====
  const [partNo, setPartNo] = useState("");
  const [partDesc, setPartDesc] = useState("");
  const [currentProdNo, setCurrentProdNo] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [heatCode, setHeatCode] = useState("");
  const [materialCode, setMaterialCode] = useState("");
  const [drawingLevel, setDrawingLevel] = useState("");
  const [addlTxt2, setAddlTxt2] = useState("");
  const [vcode, setVcode] = useState("");
  const [vcodeList, setVcodeList] = useState([]);
  const [companyData, setCompanyData] = useState(null);
  
  // ===== STATE FOR PARTS LIST =====
  const { partsList, refreshParts } = useParts();
  const [editingId, setEditingId] = useState(null);

    useEffect(() => {
      // Get company data from localStorage (set during login)
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      if (userData.ComName && userData.ComShortCode) {
        setCompanyData(userData);
        // Don't pre-select vendor - user must select from dropdown first
      }
    }, []);

  useEffect(() => {
    refreshParts();
  }, [refreshParts]);

  useEffect(() => {
  fetchVcodeOptions();
}, []);
  // ===== FETCH VCODE OPTIONS =====
  // ===== FETCH VCODE OPTIONS =====
const fetchVcodeOptions = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const comShortCode = userData.ComShortCode || "";

    if (!comShortCode) return;

    const response = await getPartDetailsApi(comShortCode);

    if (response?.status === "success" && response.data) {

      let vcodeData = [];

      if (Array.isArray(response.data[1])) {
        vcodeData = response.data[1];
      }

      const options = vcodeData
        .filter(item => item && item.Vcode)
        .map(item => ({
          value: item.Vcode,
          label: item.Vcode
        }));

      setVcodeList(options);
    }

  } catch (error) {
    console.error("Error fetching Vcode options:", error);
  }
};


  // ===== CLEAR FORM =====
  const clearForm = () => {
    setPartNo("");
    setPartDesc("");
    setCurrentProdNo("");
    setBatchCode("");
    setHeatCode("");
    setMaterialCode("");
    setDrawingLevel("");
    setAddlTxt2("");
    setVcode("");
    setEditingId(null);
  };

  // ===== SAVE PART =====
  const savePart = () => {
    if (!partNo.trim()) {
      alert("Please enter Part No");
      return;
    }

    const normalizedPartNo = partNo.trim().toLowerCase();
    const isDuplicatePartNo = partsList.some(
      part => String(part.partNo || "").trim().toLowerCase() === normalizedPartNo
    );

    if (isDuplicatePartNo) {
      const confirmSave = window.confirm("Part No already exists. Is it ok to save with same Part No?");
      if (!confirmSave) {
        return;
      }
    }

    // Save to API - new part has partid = 0
    savePartApi({
      partid: 0,
      partNo,
      PartDesc: partDesc,
      CurrentProdNo: currentProdNo,
      BatchCode: batchCode,
      HeatCode: heatCode,
      MaterialCode: materialCode,
      Drawinglevel: drawingLevel,
      AddlTxt2: addlTxt2,
      Vcode: vcode,
      ComShortCode: companyData?.ComShortCode || JSON.parse(localStorage.getItem("userData") || "{}").ComShortCode || "",
      DActive: 1
    }).then((response) => {
      if (response.status === "success") {
        alert(response.message || "Part saved successfully");
        refreshParts();
        fetchVcodeOptions(); 
        clearForm();
      } else {
        alert(response.message || "Error saving part");
      }
    }).catch(err => {
      console.error("Error saving part:", err);
      alert("Error saving part");
    });
  };

  // ===== EDIT PART =====
  const editPart = async (id) => {
    try {
      const comShortCode = companyData?.ComShortCode || JSON.parse(localStorage.getItem("userData") || "{}").ComShortCode || "";
      const response = await editPartApi(id, comShortCode);
      
      if (response.status === "success" && response.data) {
        // Handle new API response format - data might be in nested array
        let part;
        if (Array.isArray(response.data[0])) {
          // New format: response.data[0][0] is the part object
          part = response.data[0][0];
        } else {
          // Original format: response.data is the part object
          part = response.data;
        }
        
        setPartNo(part.partNo || "");
        setPartDesc(part.PartDesc || "");
        setCurrentProdNo(part.CurrentProdNo || "");
        setBatchCode(part.BatchCode || "");
        setHeatCode(part.HeatCode || "");
        setMaterialCode(part.MaterialCode || "");
        setDrawingLevel(part.Drawinglevel || "");
        setAddlTxt2(part.AddlTxt2 || "");
        setVcode(part.Vcode || "");
        setEditingId(part.partid);
      } else {
        alert(response.message || "Part not found");
      }
    } catch (error) {
      console.error("Error fetching part:", error);
      alert("Failed to load part data");
    }
  };

  // ===== UPDATE PART =====
  const updatePart = () => {
    if (!partNo.trim()) {
      alert("Please enter Part No");
      return;
    }

    // Update via API - include editingId as partid
    savePartApi({
      partid: editingId,
      partNo,
      PartDesc: partDesc,
      CurrentProdNo: currentProdNo,
      BatchCode: batchCode,
      HeatCode: heatCode,
      MaterialCode: materialCode,
      Drawinglevel: drawingLevel,
      AddlTxt2: addlTxt2,
      Vcode: vcode,
      ComShortCode: companyData?.ComShortCode || JSON.parse(localStorage.getItem("userData") || "{}").ComShortCode || "",
      DActive: 1
    }).then((response) => {
      if (response.status === "success") {
        alert(response.message || "Part updated successfully");
        refreshParts();
        fetchVcodeOptions();
        clearForm();
      } else {
        alert(response.message || "Error updating part");
      }
    }).catch(err => {
      console.error("Error updating part:", err);
      alert("Error updating part");
    });
  };

  // ===== DELETE PART =====
  const deletePart = (id) => {
    if (window.confirm("Are you sure you want to delete this part?")) {
      deletePartApi(id).then((response) => {
        if (response.status === "success") {
          alert(response.message || "Part deactivated successfully");
          refreshParts();
          if (editingId === id) {
            clearForm();
          }
        } else {
          alert(response.message || "Error deleting part");
        }
      }).catch(err => {
        console.error("Error deleting part:", err);
        alert("Error deleting part");
      });
    }
  };

  // ===== STYLES =====
  const panelBox = {
    background: "#f5f7f9",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    padding: "24px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
  };

  const panelTitle = {
    fontSize: "13px",
    fontWeight: 700,
    color: "#1f2937",
    borderBottom: "2px solid #3b82f6",
    paddingBottom: "10px",
    marginBottom: "18px",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  };

  const compactInput = {
    width: "100%",
    height: "38px",
    padding: "6px 12px",
    fontSize: "13px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    background: "#fff",
    marginBottom: "14px",
    boxSizing: "border-box"
  };

  const labelStyle = {
    fontSize: "12px",
    fontWeight: 600,
    color: "#374151",
    marginBottom: "6px",
    display: "block"
  };

  const saveBtn = {
    width: "120px",
    background: "#16a34a",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginRight: "10px"
  };

  const updateBtn = {
    width: "120px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginRight: "10px"
  };

  const clearBtn = {
    width: "120px",
    background: "#6b7280",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  };

  const editBtn = {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 12px",
    fontSize: "12px",
    cursor: "pointer",
    marginRight: "5px"
  };

  const deleteBtn = {
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 12px",
    fontSize: "12px",
    cursor: "pointer"
  };

  // ===== HELPER FOR COLUMNS =====
  const col = (size) => ({ flex: `0 0 ${size}%`, maxWidth: `${size}%`, padding: "0 8px", boxSizing: "border-box" });
  const row = () => ({ display: "flex", flexWrap: "wrap", margin: "0 -8px" });

  return ( 
    <div style={{ background: "#e5e7eb", minHeight: "100vh" }}>

      <Sidebar currentPage="partmaster" />

      <Header title="PART MASTER" />

      {/* MAIN CONTENT */}
      <div style={{
        maxWidth: "1400px",
        margin: "30px auto",
        padding: "0 20px"
      }}>

        <div style={row()}>

          {/* LEFT PARTITION - FORM */}
          <div style={{ ...col(33), marginBottom: "20px" }}>
            <div style={panelBox}>
              <div style={panelTitle}>PART DETAILS</div>

              <div style={labelStyle}>Part No *</div>
              <input 
                style={compactInput} 
                value={partNo} 
                onChange={e => setPartNo(e.target.value)}
                placeholder="Enter Part No"
              />

              <div style={labelStyle}>Part Description</div>
              <input 
                style={compactInput} 
                value={partDesc} 
                onChange={e => setPartDesc(e.target.value)}
                placeholder="Enter Part Description"
              />

              <div style={labelStyle}>Current Prod No</div>
              <input 
                style={compactInput} 
                value={currentProdNo} 
                onChange={e => setCurrentProdNo(e.target.value)}
                placeholder="Enter Current Prod No"
              />

              <div style={labelStyle}>Batch Code</div>
              <input 
                style={compactInput} 
                value={batchCode} 
                onChange={e => setBatchCode(e.target.value)}
                placeholder="Enter Batch Code"
              />

              <div style={labelStyle}>Heat Code</div>
              <input 
                style={compactInput} 
                value={heatCode} 
                onChange={e => setHeatCode(e.target.value)}
                placeholder="Enter Heat Code"
              />

              <div style={labelStyle}>Material Code</div>
              <input 
                style={compactInput} 
                value={materialCode} 
                onChange={e => setMaterialCode(e.target.value)}
                placeholder="Enter Material Code"
              />

              <div style={labelStyle}>Drawing Level</div>
              <input 
                style={compactInput} 
                value={drawingLevel} 
                onChange={e => setDrawingLevel(e.target.value)}
                placeholder="Enter Drawing Level"
              />

              <div style={labelStyle}>Addl Text 2</div>
              <input 
                style={compactInput} 
                value={addlTxt2} 
                onChange={e => setAddlTxt2(e.target.value)}
                placeholder="Enter Addl Text 2"
              />

              <div style={labelStyle}>Vendor Code</div>
              <div style={{ position: "relative" }}>
  <input
    style={compactInput}
    list="vcode-options"
    value={vcode}
    onChange={(e) => setVcode(e.target.value)}
    placeholder="Type or Select VCode"
  />

  <datalist id="vcode-options">
    {vcodeList.map((option, index) => (
      <option key={index} value={option.value} />
    ))}
  </datalist>
</div>

              {/* BUTTONS */}
              <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                {editingId ? (
                  <button style={updateBtn} onClick={updatePart}>
                    UPDATE
                  </button>
                ) : (
                  <button style={saveBtn} onClick={savePart}>
                    SAVE
                  </button>
                )}
                
                <button style={clearBtn} onClick={clearForm}>
                  CLEAR
                </button>
              </div>
            </div>
          </div>

          {/* RIGHT PARTITION - EXISTING PARTS TABLE */}
          <div style={{ ...col(67), marginBottom: "20px" }}>
            <div style={panelBox}>
              <div style={panelTitle}>EXISTING PARTS</div>

              {/* TABLE */}
              <div style={{ overflowX: "auto" }}>
                <table style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "12px",
                  background: "#fff"
                }}>
                  <thead>
                    <tr style={{
                      background: "#374151",
                      color: "#fff"
                    }}>
                      <th style={{ padding: "10px", textAlign: "left" }}>Part No</th>
                      <th style={{ padding: "10px", textAlign: "left" }}>Description</th>
                      <th style={{ padding: "10px", textAlign: "left" }}>Prod No</th>
                      <th style={{ padding: "10px", textAlign: "left" }}>Batch</th>
                      <th style={{ padding: "10px", textAlign: "left" }}>Heat</th>
                      <th style={{ padding: "10px", textAlign: "left" }}>Material</th>
                      <th style={{ padding: "10px", textAlign: "left" }}>Drawing</th>
                      <th style={{ padding: "10px", textAlign: "left" }}>Addl Txt2</th>
                      <th style={{ padding: "10px", textAlign: "left" }}>VCode</th>
                      <th style={{ padding: "10px", textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partsList.length === 0 ? (
                      <tr>
                        <td colSpan="10" style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#6b7280",
                          fontStyle: "italic"
                        }}>
                          No parts found. Add a new part to get started.
                        </td>
                      </tr>
                    ) : (
                      partsList.map((part, index) => (
                        <tr key={part.partid} style={{
                          background: index % 2 === 0 ? "#f9fafb" : "#fff",
                          borderBottom: "1px solid #e5e7eb"
                        }}>
                          <td style={{ padding: "10px" }}>{part.partNo}</td>
                          <td style={{ padding: "10px" }}>{part.PartDesc}</td>
                          <td style={{ padding: "10px" }}>{part.CurrentProdNo}</td>
                          <td style={{ padding: "10px" }}>{part.BatchCode || "-"}</td>
                          <td style={{ padding: "10px" }}>{part.HeatCode || "-"}</td>
                          <td style={{ padding: "10px" }}>{part.MaterialCode || "-"}</td>
                          <td style={{ padding: "10px" }}>{part.Drawinglevel || "-"}</td>
                          <td style={{ padding: "10px" }}>{part.AddlTxt2 || "-"}</td>
                          <td style={{ padding: "10px" }}>{part.Vcode || "-"}</td>
                          <td style={{ padding: "10px", textAlign: "center" }}>
                            <button 
                              style={editBtn}
                              onClick={() => editPart(part.partid)}
                            >
                              EDIT
                            </button>
                            <button 
                              style={deleteBtn}
                              onClick={() => deletePart(part.partid)}
                            >
                              DELETE
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default PartMaster;
